import React from 'react';


import MonacoMySql from 'components/MonacoEditor/MonacoMySql';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";

import { withStyles, Fab, Button } from '@material-ui/core';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import CustomButton from "components/CustomButtons/Button.jsx";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Add from '@material-ui/icons/Add';
import Check from '@material-ui/icons/Check';
import DateRange from '@material-ui/icons/DateRange';

import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import {
    cardTitle,
    roseColor
} from "assets/jss/material-dashboard-pro-react.jsx";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import ConnectionStringDialog from './ConnectionStringDialog';
import { store } from '../../redux/store';
import UserEndpoints from '../../api/UserEndpoints';
import { SET_USER_LIST, SET_EMAIL_LIST, SET_CONNECTION_LIST, SET_REPORT_LIST, SET_PAGE_TITLE, SET_SCHEDULE_LIST } from '../../redux/types';
import EmailEndpoints from '../../api/EmailEndpoints';
import EmailDialog from './EmailDialog';
import RunConfiguration from './AddOrEdit/RunConfiguration';
import Scheduling from './AddOrEdit/Scheduling';
import Api from '../../api/Api.js';
import ReportEndpoints from '../../api/ReportEndpoints';
import Loading from '../../components/Loading/Loading';
import { cleanReportName } from '../../helpers';
import SuccessModal from '../../components/Modal/SuccessModal';
import ErrorModal from '../../components/Modal/ErrorModal';

const styles = {
    cardTitle,
    cardTitleWhite: {
        ...cardTitle,
        color: "#FFFFFF",
        marginTop: "0"
    },
    cardCategoryWhite: {
        margin: "0",
        color: "rgba(255, 255, 255, 0.8)",
        fontSize: ".875rem"
    },
    cardCategory: {
        color: "#999999",
        marginTop: "10px"
    },
    icon: {
        color: "#333333",
        margin: "10px auto 0",
        width: "130px",
        height: "130px",
        border: "1px solid #E5E5E5",
        borderRadius: "50%",
        lineHeight: "174px",
        "& svg": {
            width: "55px",
            height: "55px"
        },
        "& .fab,& .fas,& .far,& .fal,& .material-icons": {
            width: "55px",
            fontSize: "55px"
        }
    },
    iconRose: {
        color: roseColor
    },
    marginTop30: {
        marginTop: "30px"
    },
    testimonialIcon: {
        marginTop: "30px",
        "& svg": {
            width: "40px",
            height: "40px"
        }
    },
    cardTestimonialDescription: {
        fontStyle: "italic",
        color: "#999999"
    }
};

class AddOrEditReport extends React.Component {

    constructor(props) {
        super(props);

        var index = -1;
        var report_id = props.match.params.id ? parseInt(props.match.params.id) : 0;
        if (report_id > 0) {
            index = props.reports.findIndex(x => x.id == report_id);
        }

        this.query = report_id > 0 ? (props.reports[index] ? props.reports[index].query : '') : '';
        this.original_query = report_id > 0 ? (props.reports[index] ? props.reports[index].query : '') : '';

        this.state = {
            add: props.match.params.mode !== 'edit',
            waiting: report_id > 0,
            submitting: false,
            success: false,
            error: false,
            report_id: report_id,
            report: report_id > 0 ? props.reports[index] : null,
            autocomplete: null,
            connection_id: 0,
            report_index: index,
            name: report_id > 0 ? (props.reports[index] ? props.reports[index].name : '') : '',
            showConnectionString: false,
            showAddEmailDialog: false,
            compareWithOriginalQuery: false,
            scheduleExpanded: true
        }

        if (report_id > 0) {
            this.state = { ...this.state, ...props.reports[index] };
            store.dispatch({ type: SET_PAGE_TITLE, payload: (props.match.params.mode === 'copy' ? "Copy" : "Edit") + " " + cleanReportName((props.reports[index] ? props.reports[index].name : '')) })
        }
    }

    original_query = "";
    query = "";

    componentDidMount() {
        this.refreshAutocomplete();
        this.refreshUsers();
        this.refreshConnections();
        this.refreshEmails();
        this.refreshSchedules();
        if (this.state.report_id > 0)
            this.refreshReportDetails();
    }

    refreshReportDetails() {
        Api.get(ReportEndpoints.detail, { id: this.state.report_id })
            .then(({ data }) => {
                console.log(data);
                var new_reports = [].concat(this.props.reports);
                new_reports[this.state.report_index] = data;
                this.query = data.query;
                this.setState({ report: data, ...data, waiting: false });
                store.dispatch({ type: SET_REPORT_LIST, payload: new_reports })
            })
            .catch((e) => {
                console.error("Failed to Retrieve autocomplete information", e);
            });
    }

    refreshAutocomplete() {
        Api.get(ReportEndpoints.autocomplete, { connection_id: this.state.connection_id })
            .then(({ data }) => {
                this.setState({ autocomplete: data });
            })
            .catch((e) => {
                console.error("Failed to Retrieve autocomplete information", e);
            });
    }

    refreshConnections() {
        Api.get(ReportEndpoints.listConnections)
            .then(({ data }) => {
                store.dispatch({ type: SET_CONNECTION_LIST, payload: data })
            })
            .catch((e) => {
                console.error("Failed to Retrieve connection list", e);
            });
    }

    addEmail(email) {
        Api.get(EmailEndpoints.add, { email })
            .then(({ data }) => {
                store.dispatch({ type: SET_EMAIL_LIST, payload: this.props.emails.concat([data]) })
            });
    }

    refreshEmails() {
        Api.get(EmailEndpoints.list)
            .then(({ data }) => {
                store.dispatch({ type: SET_EMAIL_LIST, payload: data })
            })
            .catch((e) => {
                console.error("Failed to Retrieve emails information", e);
            });
    }

    refreshUsers() {
        Api.get(UserEndpoints.list)
            .then(({ data }) => {
                store.dispatch({ type: SET_USER_LIST, payload: data })
            })
            .catch((e) => {
                console.error("Failed to Retrieve users information", e);
            });
    }

    refreshSchedules() {
        Api.get(ReportEndpoints.scheduleList)
            .then(({ data }) => {
                store.dispatch({ type: SET_SCHEDULE_LIST, payload: data })
            })
            .catch((e) => {
                console.error("Failed to Retrieve users information", e);
            });
    }

    replaceSelectionWith(text) {
        var currentSelection = this.refs.monaco_sql.refs.editorRef.editor.getSelection();
        this.refs.monaco_sql.refs.editorRef.editor.getModel().applyEdits([{
            range: currentSelection,
            text
        }]);
    }

    editorRef;
    monaco;

    submit() {
        this.setState({ submitting: true }, () => {
            var payload = {
                ...this.runConfig.getConfig(),
                ...this.scheduling.getSchedule(),
                connection_id: this.state.connection_id,
                ...(this.state.report_id > 0 ? { id: this.state.report_id } : {}),
                ...{
                    name: this.state.name,
                },
                query: this.query,
            }
            delete payload.connection_string;

            Api.post(ReportEndpoints[this.state.add ? "add" : "edit"], payload)
                .then(({ data }) => {
                    console.log(data);
                    this.setState({ submitting: false, success: true, report_id: data.id })
                })
                .catch((e) => {
                    console.error(e);
                    this.setState({ submitting: false, error: true })
                })
        })
    }

    render() {
        const { classes } = this.props;

        if (this.state.waiting)
            return <Loading />

        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                    <Card>
                        <CardHeader color="success" text>
                            <CardText color="success">
                                <h4 className={classes.cardTitleWhite}>Report Details</h4>
                            </CardText>
                        </CardHeader>
                        <CardBody>
                            <CustomInput
                                success={this.state.nameState === "success"}
                                error={this.state.nameState === "error"}
                                labelText={
                                    <span>
                                        Name <small>(required)</small>
                                    </span>
                                }
                                id="name"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={{
                                    onChange: event => this.setState({ name: event.target.value }),
                                    value: this.state.name,
                                }}
                            />
                            <hr />
                            <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                            >
                                <InputLabel
                                    htmlFor="connection_id"
                                    className={classes.selectLabel}
                                    shrink={this.state.connection_id !== 0}
                                >
                                    Select Connection
                                </InputLabel>
                                <Select
                                    MenuProps={{
                                        className: classes.selectMenu
                                    }}
                                    classes={{
                                        select: classes.select
                                    }}
                                    value={this.state.connection_id}
                                    onChange={(event) => this.setState({ connection_id: event.target.value }, () => this.refreshAutocomplete())}
                                    inputProps={{
                                        name: "connection_id",
                                        id: "connection_id"
                                    }}
                                    color="rose"
                                >
                                    <MenuItem disabled classes={{ root: classes.selectMenuItem }}>Select Connection</MenuItem>
                                    {
                                        (this.props.connections || []).map(x =>
                                            <MenuItem
                                                key={x.id}
                                                classes={{
                                                    root: classes.selectMenuItem,
                                                    selected: classes.selectMenuItemSelected
                                                }}
                                                value={x.id}
                                            >
                                                {x.name}
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                            </FormControl>
                            <div style={{ minHeight: 40 }}>
                                <Fab style={{ float: 'right' }} variant="extended" color="primary" onClick={() => this.setState({ showConnectionString: true })}>
                                    <Add /> Add Connection
                                </Fab>
                            </div>
                            <br />

                            <ConnectionStringDialog
                                isOpen={this.state.showConnectionString}
                                close={() => this.setState({ showConnectionString: false })}
                                refresh={() => {
                                    //TODO: Add new connection string to list
                                }}
                            />

                            <EmailDialog
                                isOpen={this.state.showAddEmailDialog}
                                close={() => this.setState({ showAddEmailDialog: false })}
                                CreateEmail={(email) => this.addEmail(email)}
                            />

                            <RunConfiguration
                                innerRef={(ref) => this.runConfig = ref}
                                onEmailOpenClick={() => this.setState({ showAddEmailDialog: true })}
                                emailCreated={(email) => store.dispatch({ type: SET_EMAIL_LIST, payload: this.props.emails.concat([email]) })}
                                report={this.state.report}
                                emails={this.props.emails}
                                users={this.props.users}
                            />

                            <ExpansionPanel style={{ boxShadow: 'none', borderRadius: 8, border: 'none', borderTop: 'none' }} expanded={this.state.scheduleExpanded} onChange={() => this.setState({ scheduleExpanded: !this.state.scheduleExpanded })}>
                                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} >
                                    <h5>Schedule</h5>
                                </ExpansionPanelSummary>
                                <ExpansionPanelDetails>
                                    <Scheduling
                                        innerRef={(ref) => this.scheduling = ref}
                                        schedules={this.props.schedules}
                                        report={this.state.report}
                                    />
                                </ExpansionPanelDetails>
                            </ExpansionPanel>

                            {
                                this.state.submitting ?
                                    <Loading />
                                    :
                                    <CustomButton block round color="rose" onClick={() => this.submit()}>
                                        Save Changes <Check />
                                    </CustomButton>
                            }
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Card>
                        <CardHeader color="rose" text>
                            <CardText color="rose">
                                <h4 className={classes.cardTitleWhite}>Query</h4>
                            </CardText>
                        </CardHeader>
                        <CardBody>
                            <Button variant="text" onClick={() => this.replaceSelectionWith("{prev;1;00:00:00;sql}")}>1st <DateRange /></Button>
                            <Button variant="text" onClick={() => this.replaceSelectionWith("{this;today;now;sql}")}>Now <DateRange /></Button>
                            <Button variant="text" onClick={() => this.replaceSelectionWith("{prev;last;23:59:59;sql}")}>31st <DateRange /></Button>
                            <hr />
                            <MonacoMySql
                                ref={"monaco_sql"}
                                autocomplete={this.state.autocomplete}
                                onChange={(value) => this.query = value}
                                defaultValue={this.query}
                                height="500"
                                theme={this.state.dark ? "vs-dark" : "default"}
                                editorDidMount={(editor, monaco) => { this.editorRef = editor; this.monaco = monaco; }}
                            />
                        </CardBody>
                    </Card>
                    <SuccessModal open={this.state.success} close={() => this.setState({ success: false }, () => store.dispatch(push('/reports/edit/' + this.state.report_id)))}>
                            Success! You're report has successfully been changed!
                    </SuccessModal>

                    <ErrorModal open={this.state.error} close={() => this.setState({ error: false })}>
                            Error! Something went horribly wrong when you tried to save this report...
                    </ErrorModal>
                </GridItem>
            </GridContainer>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        connections: state.reports.connection_strings,
        emails: state.emails.list,
        users: state.allUsers.list,
        reports: state.reports.list,
        schedules: state.reports.schedules
    };
}

export default withStyles({ ...extendedFormsStyle, ...styles })(connect(mapStateToProps)(AddOrEditReport));